"use strict";

// типы полей для заданий с подстановкой
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonTaskGapsEnum = void 0;
var LessonTaskGapsEnum;
(function (LessonTaskGapsEnum) {
  /* Подстановка в виде перетаскивания или выбора из общего списка вариантов */
  LessonTaskGapsEnum[LessonTaskGapsEnum["Dropbox"] = 1] = "Dropbox";
  /* Подстановка из отдельного списка вариантов */
  LessonTaskGapsEnum[LessonTaskGapsEnum["Selectbox"] = 2] = "Selectbox";
  /* Подстановка в виде ручного ввода (текст/число) */
  LessonTaskGapsEnum[LessonTaskGapsEnum["Inputbox"] = 3] = "Inputbox";
})(LessonTaskGapsEnum = exports.LessonTaskGapsEnum || (exports.LessonTaskGapsEnum = {}));
